import { EncounterPayload } from '_api/types';
import {
  CheckboxField,
  InputField,
  LocalizedDatePicker,
  RadioButtonField,
} from 'components/molecules/formFields';
import { noop } from 'lodash';
import React, { useState } from 'react';
import { useEncounter } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { BaseFormProps } from './types';

export const EncounterForm = ({
  initValue,
  onBack = noop,
  onSubmit,
  disableAll = false,
  hideSubmitButtons = false,
}: BaseFormProps<EncounterPayload>) => {
  const { communicationOptions } = useEncounter({});
  const [checkedInteraction, setCheckedInteraction] = useState<boolean>(
    !!initValue.contactMethod,
  );

  const back = () => {
    setCheckedInteraction(false);
    onBack();
  };

  const update = async (key: any, arg: any) => {
    if (key === 'interactionOccurred') setCheckedInteraction(arg);
  };

  const baseFields = [
    {
      component: LocalizedDatePicker,
      fieldKey: 'date_of_observation',
      label: 'DATE',
      xs: 6,
    },
    {
      component: InputField,
      fieldKey: 'minutes',
      label: 'TIME SPENT MINUTES',
      type: 'number',
      endAdornment: 'minutes',
      required: true,
      xs: 6,
    },
    {
      component: CheckboxField,
      fieldKey: 'interactionOccurred',
      checkboxLabel: 'Check if you had an interaction with the patient or guardian.',
    },
  ];

  const radioButtons = [
    {
      component: RadioButtonField,
      fieldKey: 'contactMethod',
      label: 'HOW DID YOU SPEAK WITH THE PATIENT OR GUARDIAN?',
      options: communicationOptions,
      row: true,
      xs: 12,
    },
  ];

  const formFields = !checkedInteraction ? baseFields : [...baseFields, ...radioButtons];

  return (
    <FormBuilder
      initValues={initValue}
      formFields={formFields}
      onBack={!hideSubmitButtons ? back : undefined}
      onSubmit={onSubmit}
      onUpdate={update}
      disabled={disableAll}
      hideSubmit={hideSubmitButtons}
      backLabel={'Cancel'}
    />
  );
};
